import { SaudiRiyalIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@virtual-care/shadcn';

export function PriceLine({
  className,
  value,
}: {
  className?: string;
  value?: string;
}) {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        className,
        'flex items-center justify-between rounded-md border border-green-500 bg-green-50/50 p-2',
      )}
    >
      <span className="text-muted-foreground">{t('pricing.servicePrice')}</span>
      <span className="text-primary flex items-center justify-center gap-1 text-base font-semibold">
        {isNaN(Number(value)) ? value : Number(value) / 100}
        <SaudiRiyalIcon className="h-5 w-5" />
      </span>
    </div>
  );
}
